import styled from "styled-components";
import { ReactComponent as calculate } from "../../assets/icons/calculator.svg";
import { ReactComponent as house } from "../../assets/icons/cardHouse.svg";
import { ReactComponent as map } from "../../assets/icons/cardMaps.svg";
import { ReactComponent as massage } from "../../assets/icons/cardMassage.svg";

export const Basic = styled.div`
  width: 100%;
  background: #f6f8f9;
`;
export const Container = styled.div`
  padding: 100px 0px;
  display: flex;
  margin: auto;
  flex-direction: column;
  align-items: center;
  max-width: 1475px;
  min-width: 500px;
  height: auto;
`;
export const Div = styled.div`
display: flex;
flex-direction: ${({ column }) => `${column && "column"}`};
margin: auto;
`;
export const Text = styled.h1`
  font-family: Cerebri Sans;
  font-style: normal;
  font-weight: 600;
  font-size: ${({ size }) => `${size ? size : "18px"}`};
  line-height: 38px;
  text-align: center;
  color: var(--colorBlack);
`;
Text.Title = styled.h1`
  font-family: Cerebri Sans;
  font-style: normal;
  font-weight: normal;
  font-size: ${({ size }) => `${size ? size : "14px"}`};
  line-height: 20px;
  text-align: center;
  color: var(--colorText);
  margin-bottom: ${({ siz }) => `${siz && "50px"}`};
`;
export const Top = styled.div`
  display: flex;
  flex: 1;
`;
export const Box = styled.div`
  margin: auto;
  margin-bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 112px;
  height: 112px;
  border-radius: 50%;
`;
export const Massage = styled(massage)`
  path {
    fill: blue !important;
  }
`;
export const Calculate = styled(calculate)``;
export const House = styled(house)``;
export const Map = styled(map)``;
export const Bottom = styled.div`
  padding: 0px 35px 45px 35px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`;
